export default "__VITE_ASSET__CzxMG9f$__ 48w, __VITE_ASSET__WcKb8_SW__ 96w, __VITE_ASSET__DIoQmVMm__ 144w";